<template>
    <div class="blog-news-carousel">
        <h3 class="blog-news-carousel__title" :class="{black: blogPage}">
            Últimas Atualizações
        </h3>
        <div>
            <carousel :perPage="4"
                      :perPageCustom="[[300, 1], [768, 2], [1024, 2], [1280, 3], [1366, 4]]"
                      :navigationEnabled="true"
                      :autoplay="true"
                      :autoplayTimeout="3000"
                      :speed="1000"
                      :loop="true"
                      class="my-card"
                      :paginationEnabled="false">
                <slide v-for="(card, index) in posts" :key="index + 'blonewsCarousel'">
                    <BlogCard
                            :cat-title="card.categoria.name"
                            :flag="card.categoria.color"
                            :id="card.id"
                            :footer="true"
                            :img="card.file"
                            :title="card.title"
                            :desc="card.text"/>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
    import BlogCard from "./BlogCard";
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "BlogNewsCarousel",
        props: ['blogPage', 'footer'],
        data() {
            return {
                posts: [],
            }
        },
        methods: {
            fetchPosts() {
                axios.get('/blog')
                    .then(r => {
                        this.posts = r.data.data.reverse();
                    })
            }
        },
        components: {
            BlogCard,
            Carousel,
            Slide
        },
        mounted() {
            this.fetchPosts();
        }
    }
</script>

<style lang="scss" scoped>

    .my-card {
        margin: 0 auto;
    }

    .blog-news-carousel {
        max-width: 1140px;
        margin: 0 auto;

        &__title {
            font-family: Poppins, Arial, sans-serif;
            font-weight: 500;
            font-size: 1.75rem;
            color: #fff;
            padding-top: 60px;
            margin-bottom: 40px;
        }
    }

    .black {
        color: #2b2b2b;
    }

    @media only screen and(max-width: 1366px) {
        .blog-news-carousel {
            max-width: 840px;
        }
    }

    @media only screen and(max-width: 1200px) {
        .blog-news-carousel {
            max-width: 560px;
        }
    }


    @media only screen and (max-width: 767px) {
        .blog-news-carousel {
            max-width: 300px;
        }

        .blog-news-carousel__title {
            margin-left: -10px;
        }

        .item {
            margin: 0 auto;
        }
    }
</style>